export class ClsTercerosDomicilioModel {
    public TER_ID: number;
    public TER_IDENTIFICACION: string;
    public TER_NOMBRE: string;
    public TER_TELEFONO: string;
}
